import { Injectable } from '@angular/core';
import * as firebase from "firebase";
import { Http, Headers } from '@angular/http';

@Injectable()
export class ElasticSearchService {
  database = firebase.database();
  constructor(private http: Http) { }

  doSearch(term: any, data: any) {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http.post(`https://testapi.bigadvice.com/entity/searchBy${term}`, data, { headers: headers }).map(res => res.json()).map(res => res.map(elem => JSON.parse(elem))).toPromise();
  }
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/core/services/elastic-search.service.ts